import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import companyReducer from './companySlice';
import importReducer from './importSlice';
import layoutReducer from './layoutSlice';
import widgetReducer from './widgetSlice';

export default configureStore({
  reducer: {
    auth: authReducer,
    company: companyReducer,
    import: importReducer,
    layout: layoutReducer,
    widget: widgetReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    immutableCheck: false,
    serializableCheck: false,
  }),
});
